export default "__VITE_ASSET__Dn0A1R9L__"